//frontend/src/components/api/auth.js

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;
const IS_DEV_NO_AUTH = process.env.REACT_APP_DEV_NO_AUTH === "true";

export async function getCurrentUser() {
  const accessToken = localStorage.getItem("access_token");

  // 1) Реальный токен → реальный пользователь.
  //    Так dev-no-auth не перетирает настоящий логин (hongwei → hongwei).
  if (accessToken) {
    try {
      const res = await fetch(`${BASE_URL}/api/me/`, {
        method: "GET",
        headers: {
          Authorization: `JWT ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        // 401 — токен протух. Не подменяем фейком: пусть ProtectedRoute
        // отправит на повторный логин (или authFetch сделает refresh).
        return null;
      }

      return await res.json();
    } catch (err) {
      console.error("Ошибка получения пользователя:", err);
      return null;
    }
  }

  // 2) Токена нет → dev-bypass (или null в проде).
  if (IS_DEV_NO_AUTH) {
    return {
      id: 1,
      username: "pantecs",
      name: "pantecs",
      groups: ["administrators"], // Поменяй на ["procurement"], если тестируешь менеджера
      is_superuser: true,
      matrix: {
        user_id: "@pantecs_1:ruschinawiki.duckdns.org",
        access_token: "fake_token_for_dev",
      },
    };
  }

  return null;
}

export async function refreshAccessToken() {
  const refresh = localStorage.getItem("refresh_token");

  if (!refresh) {
    return false;
  }

  try {
    const res = await fetch(`${BASE_URL}/api/token/refresh/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh }),
    });

    if (!res.ok) {
      return false;
    }

    const data = await res.json();

    localStorage.setItem("access_token", data.access);

    return true;
  } catch (err) {
    console.error("Ошибка обновления токена:", err);
    return false;
  }
}